import http from './api'

const route = 'app/financeiro/contas-receber/'

export default {
  showValoresAReceber: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showValoresAReceber', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValoresRecebidos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresRecebidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoValoresRecebidos: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showRelacaoValoresRecebidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValoresAbertos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresAbertos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoAbertosRecebidos: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showRelacaoAbertosRecebidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValoresVencidos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresVencidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoVencidoRecebidos: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showRelacaoVencidoRecebidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValorInadimplencia: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showValorInadimplencia', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showAcompanhamentoDiario: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showAcompanhamentoDiario', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showPMV: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showPMV', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showPMR: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showPMR', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showJurosReceber: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showJurosReceber', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDescontoReceber: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDescontoReceber', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showClientesInadimplentes: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showClientesInadimplentes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showShareInadimplencia: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showShareInadimplencia', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValorTituloVencidos: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showValorTituloVencidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValorTituloVencidoVinteDias: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showValorTituloVencidoVinteDias', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showMovimentacaoMesAMes: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showMovimentacaoMesAMes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDadosDelhamento: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDadosDelhamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDadosMovimentacaoAnual: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDadosMovimentacaoAnual', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDelhamentoValorRecebido: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDelhamentoValorRecebido', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDadosExapandCategoria: (categoria, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosExapandCategoria', {
      categoria: categoria,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosExapandNome: (nome, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosExapandNome', {
      nome: nome,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosExapandConta: (nome, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosExapandConta', {
      nome: nome,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosExapandCategoriaNome: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosExapandCategoriaNome', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosCategoriaConta: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosCategoriaConta', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresNomeConta: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresNomeConta', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosCategoriaNomeConta: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosCategoriaNomeConta', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoValorAberto: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDelhamentoValorAberto', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showDetalhamentoValorAbertoLancamento: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDetalhamentoValorAbertoLancamento', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDetalhamentoValorAbertoVencimento: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDetalhamentoValorAbertoVencimento', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDetalhamentoLancamentoVencimento: (value, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDetalhamentoLancamentoVencimento', {
      value: value,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDelhamentoValorVencido: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDelhamentoValorVencido', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showValorVencidoNome: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValorVencidoNome', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresVencidosLancamento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresVencidosLancamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresVencidosDataVencimento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresVencidosDataVencimento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showVencidosLancamentoDataVencimento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showVencidosLancamentoDataVencimento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showNomeLancamentos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showNomeLancamentos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showNomeDataVencimento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showNomeDataVencimento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showNomeLancamentoData: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showNomeLancamentoData', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showHistoricoInadimplencia: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showHistoricoInadimplencia', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showHistoricoInadimplenciaMensal: (data, select, tokenContrato) => {
    return http.post(route + 'showHistoricoInadimplenciaMensal', {
      dataInicio: data,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosHistoricoInadimplencia: (dataInicio, dataFim, select, tokenContrato, clientes) => {
    return http.post(route + 'showDadosHistoricoInadimplencia', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showHistoricoInadimplenciaClientes: (dataInicio, dataFim, select, valorReceber, tokenContrato, clientes) => {
    return http.post(route + 'showHistoricoInadimplenciaClientes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      valorReceber: valorReceber,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showHistoricoInadimplenciaClientesNomes: (dataInicio, dataFim, select, valorReceber, valorVencido, tokenContrato, clientes) => {
    return http.post(route + 'showHistoricoInadimplenciaClientesNomes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      valorReceber: valorReceber,
      valorVencido: valorVencido,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showHistoricoInadimplenciaClientesLancamento: (dataInicio, dataFim, select, valorReceber, valorVencido, tokenContrato, clientes) => {
    return http.post(route + 'showHistoricoInadimplenciaClientesLancamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      valorReceber: valorReceber,
      valorVencido: valorVencido,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },

  showInadimplenciaClientesNomeLancamento: (dataInicio, dataFim, select, valorReceber, valorVencido, tokenContrato, clientes) => {
    return http.post(route + 'showInadimplenciaClientesNomeLancamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      valorReceber: valorReceber,
      valorVencido: valorVencido,
      tokenContrato: tokenContrato,
      clientes: clientes,
    })
  },
}
